<app-ad-landingpage-top-bar></app-ad-landingpage-top-bar>
<div class="ui-g-12">

  <div class="ui-g p-md-1 secondary-cons-color" style="padding-bottom: 0;">
    <div class="ui-g-12 mt-lg-5" style="padding-bottom: 0;">
      <div class="ui-g" style="padding-bottom: 0;">
        <div class="ui-lg-1"></div>
        <div class="ui-sm-12 ui-lg-5">
          <h2 *ngIf="!this.is_uk_country;else ukcountry" class="font-size-22px-least egd-theme-text font-weight-bold">
            Expert Second Medical Opinion
          </h2>
          <ng-template #ukcountry>
            <h4 class="font-size-22px-least egd-theme-text font-weight-bold">Specialist Consultation</h4>
          </ng-template>
          <p class="heading5">
            Get a second medical opinion for treatments, surgeries, or reports
            from our board-certified doctors across the world.
          </p>
          <p id="ind-spec-sec-banner" class="card-amount-text">
            <span class="card-amount">Specialist consultation from India</span><br />
            <span class="card-amount-text egd-color">₹999.00</span>
          </p>
          <p id="ind-spec-sec-banner" class="card-amount-text">
            <span class="card-amount">Specialist consultation from UK/US</span><br />
            <span class="card-amount-text egd-color">₹7500.00</span>
          </p>
          <p class="card-amount-text" id="second-indiaspecialist-banner"></p>
          <p class="card-amount-text">
            <span id="spl-sec-banner" class="card-amount"></span>
          </p>
          <p class="card-amount-text" id="secondary-specialist-banner"></p>
          <ul class="card-ul-text">
            <li class="card-li-txt">
              Consult doctors for informed health choices.
            </li>
          </ul>
          <button type="button" class="btn btn-default btn-primary egd-theme-white-bg-btn my-3">
            <span class="egd-theme-white-bg-btn-label" [routerLink]="['/', this.slug, 'consult-doctor']"
              [queryParams]="{consultation_type_id: 1}">Consult Now</span>
          </button>
        </div>
        <div class="ui-sm-12 ui-lg-5 text-center pricing-model" style="padding-bottom: 0;">
          <img loading="lazy" class="lazyload pricing-model-secondary img-fluid"
            src="../../../../assets/images/pricing2model.png" alt="pricing eglobaldoctors" />
        </div>
      </div>
    </div>
  </div>


  <div class="ui-g">
    <div class="ui-g-12"></div>
    <div class="ui-g-12"></div>
  </div>

  <div class="ui-g">
    <div class="ui-g-12">
      <div class="card three-d-card" style="width: 88%; margin-right: auto; margin-left: auto">
        <div class="card-body">
          <h4 class="card-title egd-color font-weight-bolder ml-1">Features</h4>

          <div class="card-text">
            <ul class="font-weight-500">
              <li class="card-li-txt heading5">
                <span *ngIf="this.is_uk_country">Access to GMC registered UK specialist doctors.</span><span *ngIf="!this.is_uk_country">Access to doctors from USA, UK, India and other parts of
                  the world</span><br />
                <a class="egd-color" target="viewAllDoctors"
                  (click)="openLink('HOMPAGE_BASE_URL','#featured-doctors','_self');">
                  <span *ngIf="this.is_primary_provider">(View Doctors)</span>
                </a>
                <i class="fa fa-arrow-left arrowfeatures pkg-features-arrow" aria-hidden="true" *ngIf="!this.is_uk_country"></i>
              </li>
              <li class="card-li-txt heading5">
                Our Specialties - Internal Medicine, Cardiology, Orthopedics,
                Oncology, Pediatrics, Psychiatry and many more.
                <a class="egd-color" target="viewAllSpecialties"
                  (click)="openLink('HOMPAGE_BASE_URL','#our-service','_self');">
                  <span *ngIf="this.is_primary_provider">(View Specialties)</span>
                </a>
                <i class="fa fa-arrow-left arrowfeatures pkg-features-arrow" aria-hidden="true" *ngIf="!this.is_uk_country"></i>
              </li>
              <li class="card-li-txt heading5">
                Consult doctors for informed health choices.
              </li>
              <li class="card-li-txt heading5">
                Doctor response time same day or 1-3 days.
              </li>
              <li class="card-li-txt heading5">
                Support response time 2-3 hours.
              </li>

              <li class="card-li-txt heading5">
                Family Members can participate live via Video Physician
                Consultation from any part of the world.
              </li>
              <li class="card-li-txt heading5">
                Video Consultation upto 30 minutes.
              </li>

              <li class="card-li-txt heading5">
                No restrictions on pre existing medical conditions.
              </li>
              <li class="card-li-txt heading5">
                In-app messaging with doctor after consultation.
              </li>
              <li class="card-li-txt heading5">
                ID and Portable Health Passports.
              </li>
              <li class="card-li-txt heading5">
                These packages are applicable only for Primary Consultations and
                <span *ngIf="!this.is_uk_country">Expert Second Medical Opinion.</span><span *ngIf="this.is_uk_country">Specialist Consultation.</span>
              </li>
              <li class="card-li-txt heading5">
                Package subscription can be extended; it cannot be canceled.
              </li>
              <li class="card-li-txt heading5">
                If the subscribed package is not used in 6 months from the date
                of purchase; subscription can be extended to one year.
              </li>
              <li class="card-li-txt heading5">
                The numbers are subject to change under the authority of
                eGlobalDoctors.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="ui-g">
    <div class="ui-g-12"></div>
  </div>

  <div style="align-items: center">
    <div class="ui-g-12">
      <div class="text-align-center" style="
          margin-left: auto;
          margin-right: auto;
          margin-top: 3rem;
          justify-content: center;
        ">
        <button pButton class="btn font-weight-bolder heading4" type="button" (click)="exploremore = !exploremore"
          [label]="exploremore ? 'Explore Less' : 'Explore More'"
          style="border: 2px solid; border-radius: 5px"></button>
      </div>
    </div>
    <div *ngIf="exploremore">
      <ng-container>
        <div class="ui-g-12 text-align-center py-5">
          <h1 class="egd-heading">Choose your Consultation Type</h1>
        </div>
        <div class="ui-g-12"></div>
        <div class="ui-g-12" id="pricing">
          <div class="card-deck">
            <div class="ui-g">
              <div class="ui-sm-12 ui-md-8 offset-lg-0 ui-lg-4 my-3 d-flex pricing-card-div">
                <div class="card three-d-card h-100 w-100">
                  <div class="card-body d-flex flex-column flex-grow-1">
                    <h4 class="card-title mt-3 pb-3 pricing-card-heading">
                      Primary Consultation
                    </h4>
                    <div class="ml-md-4 pl-md-1 mb-3" id="thurday_pricing">
                      <span class="card-li-txt">
                        <b>
                          <span class="strikethrough notranslate">₹499</span>
                          <span class="card-amount-text egd-color notranslate">₹199 (60% OFF)*</span> </b><br />
                        Consultation charges- Tuesday, Thursday, and Saturday*.
                      </span>
                    </div>
                    <div class="ml-md-4 pl-md-1 mb-3">
                      <p class="card-amount-text" id="primary-internist-label">
                        <span class="card-amount">General Medicine/Internal Medicine</span>
                      </p>
                      <span class="card-li-txt">
                        <b>
                          <span class="strikethrough notranslate">₹499.00</span>
                          <span class="card-amount-text egd-color notranslate">₹449.10 (10% OFF)</span> </b><br />
                      </span>
                    </div>
                    <div class="ml-md-4 pl-md-1 mb-3">
                      <p class="card-amount-text" id="primary-internist-label">
                        <span class="card-amount">Specialist consultation from India</span>
                      </p>
                      <span class="card-li-txt">
                        <b>
                          <span class="strikethrough notranslate">₹499.00</span>
                          <span class="card-amount-text egd-color notranslate">₹449.10 (10% OFF)</span> </b><br />
                      </span>
                    </div>
                    <div class="ml-md-4 pl-md-1 mb-3">
                      <p class="card-amount-text" id="primary-internist-label">
                        <span class="card-amount">Specialist consultation from UK/US</span>
                      </p>
                      <span class="card-li-txt">
                        <b>
                          <span class="card-amount-text egd-color notranslate">₹7500.00</span> </b><br />
                      </span>
                    </div>
                    <ul class="">
                      <li class="card-li-txt">
                        Consult doctors for informed health choices.
                      </li>
                    </ul>
                  </div>
                  <div class="text-align-center mt-auto">
                    <button type="button" [routerLink]="['/', this.slug, 'consult-doctor']" [queryParams]="{consultation_type_id: 2}"
                      class="btn btn-default btn-primary white-theme-egd-bg-btn" role="button">
                      <span class="white-theme-egd-bg-btn-label">Consult Now</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="ui-sm-12 ui-md-8 offset-lg-0 ui-lg-4 my-3 d-flex pricing-card-div">
                <div class="card three-d-card h-100 w-100">
                  <div class="card-body d-flex flex-column flex-grow-1">
                    <h4 *ngIf="!this.is_uk_country;else ukcountry1" class="card-title mt-3 pb-3 pricing-card-heading">
                      Expert Second Medical Opinion
                    </h4>
                    <ng-template #ukcountry1>
                      <h4 class="card-title mt-3 pb-3 pricing-card-heading">Specialist Consultation</h4>
                    </ng-template>
                    <div class="ml-md-4 pl-md-1 mb-3">
                      <p class="card-amount-text" id="primary-internist-label">
                        <span class="card-amount">Specialist Consultation from India</span>
                      </p>
                      <span class="card-li-txt">
                        <b><span class="card-amount-text egd-color notranslate">₹999.00</span></b><br />
                      </span>
                    </div>
                    <div class="ml-md-4 pl-md-1 mb-3">
                      <p class="card-amount-text" id="primary-internist-label">
                        <span class="card-amount">Specialist consultation from UK/US</span>
                      </p>
                      <span class="card-li-txt">
                        <b><span class="card-amount-text egd-color notranslate">₹7500.00</span></b><br />
                      </span>
                    </div>
                    <ul class="">
                      <li class="card-li-txt">
                        Consult doctors for informed health choices.
                      </li>
                    </ul>
                  </div>
                  <div class="text-align-center mt-auto">
                    <button type="button" [routerLink]="['/', this.slug, 'consult-doctor']" [queryParams]="{consultation_type_id: 2}"
                      class="btn btn-default btn-primary white-theme-egd-bg-btn" role="button">
                      <span class="white-theme-egd-bg-btn-label">Consult Now</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="ui-sm-12 ui-md-8 offset-lg-0 ui-lg-4 my-3 d-flex pricing-card-div">
                <div class="card three-d-card h-100 w-100">
                  <div class="card-body d-flex flex-column flex-grow-1">
                    <h4 class="card-title mt-3 pb-3 pricing-card-heading">
                      Multi-Specialty Consultation
                    </h4>
                    <div class="ml-md-4 pl-md-1 mb-3">
                      <p class="card-amount-text" id="primary-internist-label">
                        <span class="card-amount">Specialist consultation from India</span>
                      </p>
                      <span class="card-li-txt">
                        <b>
                          <span class="card-amount-text egd-color notranslate">₹1000.00 each</span> </b><br />
                      </span>
                    </div>
                    <div class="ml-md-4 pl-md-1 mb-3">
                      <p class="card-amount-text" id="primary-internist-label">
                        <span class="card-amount">Specialist consultation from UK/US</span>
                      </p>
                      <span class="card-li-txt">
                        <b>
                          <span class="card-amount-text egd-color notranslate">₹5000.00 each</span> </b><br />
                      </span>
                      <p class="card-amount-text" id="primary-internist-label">
                        <span class="card-amount">At least 2 specialties should be selected</span>
                      </p>
                    </div>
                    <ul class="">
                      <li class="card-li-txt">
                        Consult doctors for informed health choices.
                      </li>
                    </ul>
                  </div>
                  <div class="text-align-center mt-auto">
                    <button type="button" [routerLink]="['/', this.slug, 'consult-doctor']" [queryParams]="{consultation_type_id: 4}"
                      class="btn btn-default btn-primary white-theme-egd-bg-btn" role="button">
                      <span class="white-theme-egd-bg-btn-label">Consult Now</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="ui-sm-12 ui-md-8 offset-lg-2 ui-lg-4 my-3 d-flex pricing-card-div">
                <div class="card three-d-card h-100 w-100">
                  <div class="card-body d-flex flex-column flex-grow-1">
                    <h4 class="card-title mt-3 pb-3 pricing-card-heading">
                      Follow-up Consultation
                    </h4>
                    <div class="ml-md-4 pl-md-1 mb-3">
                      <p class="card-amount-text" id="primary-internist-label">
                        <span class="card-amount">General Medicine/Internal Medicine</span>
                      </p>
                      <span class="card-li-txt">
                        <b>
                          <span class="strikethrough notranslate">₹499.00</span>
                          <span class="card-amount-text egd-color notranslate">₹449.10 (10% OFF)</span> </b><br />
                      </span>
                    </div>
                    <div class="ml-md-4 pl-md-1 mb-3">
                      <p class="card-amount-text" id="primary-internist-label">
                        <span class="card-amount">Specialist consultation from India</span>
                      </p>
                      <span class="card-li-txt">
                        <b>
                          <span class="strikethrough notranslate">₹499.00</span>
                          <span class="card-amount-text egd-color notranslate">₹449.10 (10% OFF)</span> </b><br />
                      </span>
                    </div>
                    <div class="ml-md-4 pl-md-1 mb-3">
                      <p class="card-amount-text" id="primary-internist-label">
                        <span class="card-amount">Specialist consultation from UK/US</span>
                      </p>
                      <span class="card-li-txt">
                        <b>
                          <span class="card-amount-text egd-color notranslate">₹3000.00</span> </b><br />
                      </span>
                    </div>
                    <ul class="">
                      <li class="card-li-txt">Resume your consultation.</li>
                      <li class="card-li-txt">
                        Consult doctors for informed health choices.
                      </li>
                    </ul>
                  </div>
                  <div class="text-align-center mt-auto">
                    <button type="button" (click)="openLink('PORTAL_BASE_URL','user/login/patient','_blank')"
                      class="btn btn-default btn-primary white-theme-egd-bg-btn" role="button">
                      <span class="white-theme-egd-bg-btn-label">Consult Now</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="ui-sm-12 ui-md-8 offset-lg-0 ui-lg-4 my-3 d-flex pricing-card-div">
                <div class="card three-d-card h-100 w-100">
                  <div class="card-body d-flex flex-column flex-grow-1">
                    <h4 class="card-title mt-3 pb-3 pricing-card-heading">
                      <strong>Health Passport</strong>
                    </h4>
                    <p class="health1">
                      Cost to store your medical records and prescription safely
                      and securely is
                    </p>
                    <p id="health-card-li-txt-amount" class="card-amount-text text-center">
                      <b class="notranslate"><span *ngIf="!this.is_uk_country">₹500.00/ year</span> <span *ngIf="this.is_uk_country">£150/ year</span></b>
                    </p>
                    <p>
                      Can access your health records from anywhere with our
                      Health Passport
                    </p>
                    <ul class="">
                      <li class="card-li-txt">
                        Storage Space Allocated Upto: <b>5GB</b>
                      </li>
                      <li class="card-li-txt">
                        Validity of Health Passport Upto: <b>1 Year</b>
                      </li>
                      <li class="card-li-txt"><b>24*7 Customer Support</b></li>
                    </ul>
                  </div>
                  <div class="text-align-center mt-auto">
                    <button type="button" (click)="openLink('PORTAL_BASE_URL','user/login/patient','_blank')"
                      class="btn btn-default btn-primary white-theme-egd-bg-btn" role="button">
                      <span class="white-theme-egd-bg-btn-label">Get Now</span>
                    </button>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>